import React, { FC } from 'react';

import { PackageProject } from 'api-client';
import { ProjectStatusBadge } from 'components/common/StatusBadge';
import { Money } from 'components/common/utils';
import { cn } from 'utils';

import { formatEntryDate, formatProjectExternalId, formatRoiIrr } from '../shared/packageUtils';
import styles from './PackageDetails.module.scss';

type Props = {
  projects: PackageProject[];
  emptyMessage: string;
};

export const PackageProjectsTable: FC<Props> = ({ projects, emptyMessage }) => (
  <div className={styles.tableCard}>
    <div className={cn(styles.tableHeader, styles.packageProjectsTableHeader)}>
      <div className={styles.th}>ПРОЕКТ</div>
      <div className={styles.th}>СТАТУС</div>
      <div className={styles.th}>ДАТА ВХОДА</div>
      <div className={styles.th}>ИНВЕСТИРОВАНО</div>
      <div className={styles.th}>ВОЗВРАЩЕНО</div>
      <div className={styles.th}>ПРОГНОЗ ВОЗВРАТА</div>
      <div className={styles.th}>ROI / IRR</div>
    </div>

    <div className={styles.tableBody}>
      {projects.length === 0 ? (
        <div className={styles.tableEmpty}>{emptyMessage}</div>
      ) : (
        projects.map((project) => (
          <div key={project.uuid} className={cn(styles.tableRow, styles.packageProjectsTableRow)}>
            <div className={cn(styles.td, styles.tdProject)}>
              <div className={styles.projectName}>{project.name}</div>
              <div className={styles.projectId}>ID {formatProjectExternalId(project.uuid)}</div>
            </div>
            <div className={cn(styles.td, styles.tdStatus)} data-label="Статус">
              <ProjectStatusBadge status={project.status} />
            </div>
            <div className={styles.td} data-label="Дата входа">
              {formatEntryDate(project.investmentDate)}
            </div>
            <div className={styles.td} data-label="Инвестировано">
              <Money money={project.invested} />
            </div>
            <div className={styles.td} data-label="Возвращено">
              <Money money={project.incomePaid} />
            </div>
            <div className={styles.td} data-label="Прогноз возврата">
              {project.forecastReturn ? <Money money={project.forecastReturn} /> : '—'}
            </div>
            <div className={styles.td} data-label="ROI / IRR">
              {formatRoiIrr(project.roi, project.xirr)}
            </div>
          </div>
        ))
      )}
    </div>
  </div>
);
